import { filterClasses } from "@swivl-mono/helpers";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import { VariableInputTag } from "./VariableInput.types";

export interface VariableSuggestionListHandle {
  onKeyDown(event: KeyboardEvent): boolean;
}

export interface VariableSuggestionListProps {
  items: VariableInputTag[];
  onSelect(item: VariableInputTag): void;
}

export const VariableSuggestionList = forwardRef<VariableSuggestionListHandle, VariableSuggestionListProps>(function VariableSuggestionList(
  { items, onSelect },
  ref
) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setSelectedIndex(0);
  }, [items]);

  useImperativeHandle(
    ref,
    () => ({
      onKeyDown: (event) => {
        if (!items.length) return false;
        if (event.key === "ArrowUp") {
          setSelectedIndex((i) => (i - 1 + items.length) % items.length);
          return true;
        }
        if (event.key === "ArrowDown") {
          setSelectedIndex((i) => (i + 1) % items.length);
          return true;
        }
        if (event.key === "Enter" || event.key === "Tab") {
          const item = items[selectedIndex];
          if (item) onSelect(item);
          return true;
        }
        return false;
      }
    }),
    [items, selectedIndex, onSelect]
  );

  if (!items.length) {
    return (
      <div className="VariableInput__suggestions">
        <div className="VariableInput__suggestions__empty">No variables</div>
      </div>
    );
  }

  return (
    <div className="VariableInput__suggestions">
      <div className="VariableInput__suggestions__list" role="listbox">
        {items.map((item, idx) => {
          const isFocused = idx === selectedIndex;
          return (
            <div
              key={item.id}
              role="option"
              aria-selected={isFocused}
              className={filterClasses("VariableInput__suggestions__item", isFocused && "VariableInput__suggestions__item--focused")}
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(item);
              }}
            >
              {item.display}
            </div>
          );
        })}
      </div>
    </div>
  );
});
